module.exports = __webpack_public_path__ + "img/美蔻商城.c6f17ce1.png";